import { showPopup } from "@/components/warnings/Popup";
import { showRateLimitWarning } from "@/components/warnings/ApiRateWarning";

export async function handleApiError(res: Response) {
  if (res.status === 429) {
    const data = await res.json();
    showRateLimitWarning(
      data.limitFreq,
      data.timeToResetMs
    )
    return null;
  }

  if (res.status === 400) { 
    showPopup(
      "Input Error",
      "An input error has occured. Check all inputs."
    )
    return null;
  }

  if (!res.ok) {
    showPopup(
      "Unexpected Error",
      "An unexpected error has occured."
    )
    return null;
  }
}